import {create} from 'zustand';
import {Sale} from '../models/sale.model';

interface SalesUIState {
  // Tab Management
  activeTab: 'sales' | 'statistics';
  setActiveTab: (tab: 'sales' | 'statistics') => void;

  // Pagination State
  currentPage: number;
  pageSize: number;
  setCurrentPage: (page: number) => void;
  setPageSize: (size: number) => void;

  // Search State
  searchText: string;
  setSearchText: (text: string) => void;

  // Sales Table State
  selectedSale: Sale | null;
  isDetailsModalOpen: boolean;
  loadingDetails: boolean;

  // Sales Table Actions
  setSelectedSale: (sale: Sale | null) => void;
  openDetailsModal: (sale: Sale) => void;
  closeDetailsModal: () => void;
  setLoadingDetails: (loading: boolean) => void;

  // Filter State
  showFilters: boolean;
  setShowFilters: (show: boolean) => void;

  // Utility Actions
  reset: () => void;
}

export const useSalesUIStore = create<SalesUIState>((set) => ({
  // Tab Management
  activeTab: 'sales',
  setActiveTab: (tab) => set({activeTab: tab}),

  // Pagination State
  currentPage: 1,
  pageSize: 20,
  setCurrentPage: (page) => set({currentPage: page}),
  setPageSize: (size) => set({
    pageSize: size,
    currentPage: 1 // Reset to first page when changing page size
  }),

  // Search State
  searchText: '',
  setSearchText: (text) => set({searchText: text}),

  // Sales Table State
  selectedSale: null,
  isDetailsModalOpen: false,
  loadingDetails: false,

  // Sales Table Actions
  setSelectedSale: (sale) => set({selectedSale: sale}),
  openDetailsModal: (sale) => set({
    isDetailsModalOpen: true,
    selectedSale: sale
  }),
  closeDetailsModal: () => set({
    isDetailsModalOpen: false,
    selectedSale: null,
    loadingDetails: false
  }),
  setLoadingDetails: (loading) => set({loadingDetails: loading}),

  // Filter State
  showFilters: false,
  setShowFilters: (show) => set({showFilters: show}),

  // Utility Actions
  reset: () => set({
    activeTab: 'sales',
    currentPage: 1,
    pageSize: 20,
    searchText: '',
    selectedSale: null,
    isDetailsModalOpen: false,
    loadingDetails: false,
    showFilters: false
  })
}));
